
/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'arrow-left': {
    width: 11.5,
    height: 9.9,
    viewBox: '0 0 11.5 9.9',
    data: '<path pid="0" d="M10.5 3.9H3.1l2.2-2.2c.4-.4.4-1 0-1.4-.4-.4-1-.4-1.4 0L.5 3.7c-.7.7-.7 1.8 0 2.5l3.4 3.4c.2.2.5.3.7.3.3 0 .5-.1.7-.3.4-.4.4-1 0-1.4L3.1 5.9h7.4c.6 0 1-.4 1-1s-.5-1-1-1z"/>'
  }
})
